import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-button',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss'],
    standalone: true,
    imports: [MatIconModule, CommonModule],
})
export class ButtonComponent {
    @Input() showIcon: boolean = false;
    @Input() icon: string = '';
    @Input() showLabel: boolean = true;
    @Input() label: string = 'Button';
    @Input() showCount: boolean = false;
    @Input() count?: number;
    @Input() showDisclosure: boolean = false;
    @Input() buttonClass: 'primary' | 'secondary' | 'tertiary' | 'destructive' = 'primary';
    @Input() disabled: boolean = false;

    @Output() clicked: EventEmitter<void> = new EventEmitter<void>();

    handleClick(event: Event): void {
        if (!this.disabled) {
            this.clicked.emit();
            (event.target as HTMLElement).blur();
        }
    }
}
